"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Fade: ()=>Fade
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const Fade = ({ children, className, isVisible, fadeInClass, fadeOutClass })=>{
    const fadeOutWithOpacityZero = `${fadeOutClass} opacity-0`;
    const cssClasses = (0, index_cjs_namespaceObject.cn)(`${!isVisible ? fadeOutWithOpacityZero : fadeInClass}`, className);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: cssClasses,
        "data-testid": "fade-content",
        children: children
    });
};
exports.Fade = __webpack_exports__.Fade;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Fade"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
